import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { Tables, Update } from "@/types/database";
import { qk } from "./_queryKeys";
import { assertData, throwIfError } from "./_supabaseErrors";

export type Project = Tables<"project">;

export async function getProject(): Promise<Project | null> {
  const { data, error } = await supabase.from("project").select("*").limit(1).maybeSingle();
  throwIfError(error);
  return data ?? null;
}

export async function updateProject(values: Update<"project">): Promise<Project> {
  // Single-row table: update whichever row exists (or insert later in app bootstrap).
  const existing = await getProject();
  if (!existing) {
    const { data, error } = await supabase.from("project").insert(values).select("*").single();
    throwIfError(error);
    return assertData(data);
  }
  const { data, error } = await supabase
    .from("project")
    .update(values)
    .eq("id", existing.id)
    .select("*")
    .single();
  throwIfError(error);
  return assertData(data);
}

export const projectQueryOptions = () =>
  queryOptions({
    queryKey: qk.project,
    queryFn: getProject
  });

